import { Injectable, inject } from '@angular/core';
import { WebModalService } from '@reconcept-platform/shared/ui/core/modal';
import { type ReplaySubject } from 'rxjs';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationModalOpenerService {
  private modalService = inject(WebModalService);

  // shorthand for standardised confirmationmodal
  // creates a confirmationmodal that will return true if confirmed
  askConfirmation(config: {
    title: string;
    description: string;
    alert?: string;
    // cancel button
    hideCancelButton?: boolean;
    cancelButtonText?: string;
    // cancel with result button
    cancelWithResult?: boolean; // will cancel the confirmation dialog with result: false; note that the normal cancel button will cancel with null
    cancelWithResultButtonText?: string;
    // confirm button
    confirmButtonText?: string;
    confirmButtonClass?: 'primary' | 'negative' | 'positive';
  }): ReplaySubject<boolean> {
    return this.modalService.showSimpleModal({
      component: ConfirmationModalComponent,
      data: {
        ...config,
      },
      triggerReload: false,
    });
  }
}
